/**
 * Тасовка с посевом.
 *
 * ЗАЧЕМ. Компоненты тасовали списки через `arr.sort(() => 0.5 - Math.random())`
 * прямо в setup. При SSR это выполняется дважды — на сервере и в браузере — и
 * даёт РАЗНЫЙ порядок, поэтому Vue ругался «Hydration completed but contains
 * mismatches» на главной. Посев приходит одним числом в общем пропе
 * `shuffleSeed`: он одинаков в SSR-рендере и в data-page, значит порядок
 * совпадает, а от загрузки к загрузке по-прежнему меняется.
 *
 * Заодно чинится и сама тасовка: `sort(() => 0.5 - random)` неверен —
 * компаратор обязан быть согласованным, иначе распределение перекошено и
 * зависит от движка. Здесь честный Фишер—Йетс.
 */

/** mulberry32 — маленький детерминированный ГПСЧ. */
function rng(seed) {
  let a = (Number(seed) || 1) >>> 0;
  return function () {
    a |= 0;
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/** Возвращает НОВЫЙ массив, перемешанный детерминированно по посеву. */
export function seededShuffle(arr, seed) {
  const out = Array.isArray(arr) ? arr.slice() : [];
  const next = rng(seed);
  for (let i = out.length - 1; i > 0; i--) {
    const j = Math.floor(next() * (i + 1));
    [out[i], out[j]] = [out[j], out[i]];
  }
  return out;
}
